const CR80_WIDTH_MM = 85.6
const CR80_HEIGHT_MM = 53.98
const CR80_WIDTH_PT = CR80_WIDTH_MM / 25.4 * 72
const CR80_HEIGHT_PT = CR80_HEIGHT_MM / 25.4 * 72

function latin1Bytes (value) {
  const text = String(value)
  const bytes = new Uint8Array(text.length)
  for (let i = 0; i < text.length; i++) {
    bytes[i] = text.charCodeAt(i) & 0xff
  }
  return bytes
}

function concatBytes (parts) {
  let length = 0
  for (let i = 0; i < parts.length; i++) {
    length += parts[i].length
  }
  const output = new Uint8Array(length)
  let offset = 0
  for (let i = 0; i < parts.length; i++) {
    output.set(parts[i], offset)
    offset += parts[i].length
  }
  return output
}

function byteLength (parts) {
  let length = 0
  for (let i = 0; i < parts.length; i++) {
    length += parts[i].length
  }
  return length
}

function padOffset (offset) {
  return String(offset).padStart(10, '0')
}

function sanitizeAgentPhotoIdName (fullName) {
  const cleaned = String(fullName || 'agent').trim().replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
  return cleaned || 'agent'
}

function pad2 (value) {
  return String(value).padStart(2, '0')
}

function formatAgentPhotoIdTimestamp (date) {
  const value = date || new Date()
  return value.getFullYear() +
    pad2(value.getMonth() + 1) +
    pad2(value.getDate()) + '-' +
    pad2(value.getHours()) +
    pad2(value.getMinutes()) +
    pad2(value.getSeconds())
}

function buildAgentPhotoIdFileName (fullName, extension, date) {
  return sanitizeAgentPhotoIdName(fullName) + '-' + formatAgentPhotoIdTimestamp(date) + '.' + extension
}

function buildAgentPhotoIdZipName (date) {
  return 'agent-id-cards-' + formatAgentPhotoIdTimestamp(date) + '.zip'
}

function agentDisplayName (agent) {
  const first = agent && agent.firstName ? agent.firstName : ''
  const last = agent && agent.lastName ? agent.lastName : ''
  const name = (first + ' ' + last).trim()
  return name || 'agent'
}

function dataUrlToBytes (dataUrl) {
  const marker = 'base64,'
  const index = String(dataUrl).indexOf(marker)
  const base64 = index === -1 ? String(dataUrl) : String(dataUrl).slice(index + marker.length)
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}

function buildCr80PdfFromJpegBytes (jpegBytes, pixelWidth, pixelHeight) {
  const pageWidth = CR80_WIDTH_PT.toFixed(2)
  const pageHeight = CR80_HEIGHT_PT.toFixed(2)
  const content = 'q\n' + pageWidth + ' 0 0 ' + pageHeight + ' 0 0 cm\n/Im0 Do\nQ\n'
  const objects = [
    '<< /Type /Catalog /Pages 2 0 R >>',
    '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
    '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + pageWidth + ' ' + pageHeight + '] /Resources << /XObject << /Im0 5 0 R >> >> /Contents 4 0 R >>',
    '<< /Length ' + content.length + ' >>\nstream\n' + content + 'endstream'
  ]
  const imageDict = '<< /Type /XObject /Subtype /Image /Width ' + pixelWidth +
    ' /Height ' + pixelHeight +
    ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpegBytes.length +
    ' >>\nstream\n'

  const chunks = [latin1Bytes('%PDF-1.3\n')]
  const offsets = [0]
  for (let i = 0; i < objects.length; i++) {
    offsets.push(byteLength(chunks))
    chunks.push(latin1Bytes((i + 1) + ' 0 obj\n' + objects[i] + '\nendobj\n'))
  }
  offsets.push(byteLength(chunks))
  chunks.push(latin1Bytes('5 0 obj\n' + imageDict))
  chunks.push(jpegBytes)
  chunks.push(latin1Bytes('\nendstream\nendobj\n'))

  const xrefOffset = byteLength(chunks)
  let xref = 'xref\n0 6\n0000000000 65535 f \n'
  for (let i = 1; i < offsets.length; i++) {
    xref += padOffset(offsets[i]) + ' 00000 n \n'
  }
  xref += 'trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n' + xrefOffset + '\n%%EOF'
  chunks.push(latin1Bytes(xref))
  return concatBytes(chunks)
}

function pngBytesFromCanvas (canvas) {
  return dataUrlToBytes(canvas.toDataURL('image/png'))
}

function pdfBytesFromCanvas (canvas) {
  const jpegBytes = dataUrlToBytes(canvas.toDataURL('image/jpeg', 0.92))
  return buildCr80PdfFromJpegBytes(jpegBytes, canvas.width, canvas.height)
}

async function collectPhotoIdZipEntries (agents, pack) {
  const entries = []
  const skipped = []
  const list = agents || []
  for (let i = 0; i < list.length; i++) {
    try {
      const packed = await pack(list[i])
      if (packed) {
        entries.push(packed)
      } else {
        skipped.push(list[i])
      }
    } catch (err) {
      skipped.push(list[i])
    }
  }
  return { entries: entries, skipped: skipped }
}

function photoIdZipOutcome (entryCount, skippedNames) {
  if (!entryCount) {
    return { error: 'No photo ID cards could be generated', warning: '' }
  }
  if (skippedNames && skippedNames.length) {
    return { error: '', warning: 'Skipped photo ID cards for: ' + skippedNames.join(', ') }
  }
  return { error: '', warning: '' }
}

function firstPendingUploadFile (documents) {
  const pending = documents && documents.documentsToUpload ? documents.documentsToUpload : []
  for (let i = 0; i < pending.length; i++) {
    if (pending[i] && !pending[i].error && pending[i].file) {
      return pending[i].file
    }
  }
  return null
}

function nextAvatarFormState (currentAgent, documents) {
  const pendingFile = firstPendingUploadFile(documents)
  if (!pendingFile && !(currentAgent && currentAgent.avatarFile)) {
    return null
  }
  return {
    avatarFile: pendingFile,
    deleteAvatar: pendingFile ? false : !!(currentAgent && currentAgent.deleteAvatar)
  }
}

function photoIdDisabledReason (canIssue, hasPhoto) {
  if (canIssue && hasPhoto) {
    return ''
  }
  if (canIssue) {
    return 'Add a profile photo before downloading an ID card'
  }
  return 'Photo ID is only for Agent Staff, Driver, or Terminal Supervisor'
}

function downloadBlob (blob, fileName) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

module.exports = {
  sanitizeAgentPhotoIdName,
  formatAgentPhotoIdTimestamp,
  buildAgentPhotoIdFileName,
  buildAgentPhotoIdZipName,
  agentDisplayName,
  dataUrlToBytes,
  buildCr80PdfFromJpegBytes,
  pngBytesFromCanvas,
  pdfBytesFromCanvas,
  collectPhotoIdZipEntries,
  photoIdZipOutcome,
  photoIdDisabledReason,
  firstPendingUploadFile,
  nextAvatarFormState,
  downloadBlob,
  CR80_WIDTH_MM,
  CR80_HEIGHT_MM,
  CR80_WIDTH_PT,
  CR80_HEIGHT_PT
}
